import React, { useState } from 'react';
import { getVaillantSerialNumberFormState } from '../utils/vaillantSerialNumber';

interface SeriennummerRegistrierenModalProps {
  onClose: () => void;
  onSubmit: (serialNumber: string) => void;
  onAddPhoto: (currentValue: string) => void;
  initialValue?: string;
}

const SeriennummerRegistrierenModal: React.FC<SeriennummerRegistrierenModalProps> = ({
  onClose,
  onSubmit,
  onAddPhoto,
  initialValue = '',
}) => {
  const [serialNumber, setSerialNumber] = useState(initialValue);
  const { trimmed, formatValid, canSubmit } = getVaillantSerialNumberFormState(serialNumber);

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 px-0 sm:px-4">
      <div className="w-full sm:max-w-md bg-white dark:bg-gray-800 rounded-t-2xl sm:rounded-2xl shadow-xl flex flex-col overflow-hidden">

        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            Seriennummer Registrieren
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 dark:hover:text-white min-w-[44px] min-h-[44px] flex items-center justify-center"
            aria-label="Schließen"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="px-5 py-5 space-y-4">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Die Seriennummer wird zur Registrierung an Vaillant übermittelt. Der Kunde erhält anschließend eine Bestätigungs-E-Mail von Vaillant.
          </p>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
            Seriennummer
          </label>
          <input
            type="text"
            value={serialNumber}
            onChange={(e) => setSerialNumber(e.target.value)}
            placeholder="z. B. 21054500100028300006000001N4"
            autoFocus
            className={`w-full rounded-xl border bg-white dark:bg-gray-700 text-gray-900 dark:text-white px-4 py-3 text-base focus:outline-none focus:ring-2 focus:border-transparent placeholder-gray-400 dark:placeholder-gray-500 ${
              trimmed.length > 0 && !formatValid
                ? 'border-amber-400 dark:border-amber-500 focus:ring-amber-400'
                : 'border-gray-300 dark:border-gray-600 focus:ring-primary-500'
            }`}
          />
          {trimmed.length > 0 && !formatValid && (
            <p className="mt-1.5 text-sm text-amber-700 dark:text-amber-400">
              Die eingegebene Seriennummer entspricht keinem bekannten Vaillant-Format.
            </p>
          )}
        </div>

        <div className="px-5 py-4 border-t border-gray-200 dark:border-gray-700 grid grid-cols-2 gap-3">
          <button
            onClick={() => onAddPhoto(serialNumber.trim())}
            className="min-h-[52px] rounded-xl font-semibold text-base border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
          >
            Hinzufügen
          </button>
          <button
            onClick={() => canSubmit && onSubmit(serialNumber.trim())}
            disabled={!canSubmit}
            className={`min-h-[52px] rounded-xl font-semibold text-base transition-colors ${
              canSubmit
                ? 'bg-primary-600 hover:bg-primary-700 text-white'
                : 'bg-gray-200 dark:bg-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed'
            }`}
          >
            Registrieren
          </button>
        </div>
      </div>
    </div>
  );
};

export default SeriennummerRegistrierenModal;
